import { Icon } from "@chakra-ui/react";
import { ElementType } from "react";

export default function MenuItemIcon({ icon, size = "md" }: { icon: ElementType, size?: "sm" | "md" }) {
  const boxSize = size === "sm" ? "4" : "5";
  return (
    <Icon as={icon} boxSize={boxSize} mt="2px" />
  );
}
